import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { SearchAndFilter } from './searchAndFilter';
import { EmbersDateSelect } from '../../../date';
import { EmbersMiniSelect } from '../../../select/miniSelect/miniSelect';
import { getI18nString } from '../../../utils/langUtils';
export function SearchAndFilterContainer(props) {
  var defaultMode = props.defaultMode,
    onModeChange = props.onModeChange,
    searchOptions = props.searchOptions,
    filterOptions = props.filterOptions,
    filterRows = props.filterRows,
    locale = props.locale,
    filterValue = props.filterValue,
    onFilterChange = props.onFilterChange,
    mixpanelProps = props.mixpanelProps;
  var showFilters = filterOptions && filterRows && filterValue;
  var showSearch = searchOptions;
  var handleFilterChange = function handleFilterChange(key, value) {
    var _mixpanelProps$tracke, _mixpanelProps$tracke2;
    value && (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).filterTable) === null || _mixpanelProps$tracke === void 0 ? void 0 : _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, key));
    onFilterChange && onFilterChange(_objectSpread(_objectSpread({}, filterValue), {}, _defineProperty({}, key, value)));
  };
  var handleSearch = function handleSearch(searchText) {
    var _mixpanelProps$tracke3, _mixpanelProps$tracke4, _searchOptions$onSear;
    // this means we are not tracking when user clears search input
    searchText && (mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke3 = (_mixpanelProps$tracke4 = mixpanelProps.tracker).searchTable) === null || _mixpanelProps$tracke3 === void 0 ? void 0 : _mixpanelProps$tracke3.call(_mixpanelProps$tracke4, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, searchText));
    searchOptions === null || searchOptions === void 0 || (_searchOptions$onSear = searchOptions.onSearch) === null || _searchOptions$onSear === void 0 || _searchOptions$onSear.call(searchOptions, searchText);
  };
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, (showSearch || showFilters) && /*#__PURE__*/React.createElement(SearchAndFilter, _extends({
    defaultMode: defaultMode,
    onModeChange: onModeChange
  }, showSearch ? {
    searchProps: _objectSpread(_objectSpread({}, searchOptions), {}, {
      className: 'EmbersTableTopControls-Search',
      onSearch: handleSearch
    })
  } : {}, showFilters ? {
    filterDecoratorProps: filterOptions
  } : {}), filterRows === null || filterRows === void 0 ? void 0 : filterRows.map(function (item) {
    var _item$options, _item$multiple, _item$labelKey2;
    if (item.type === 'date') {
      var itemValue = filterValue[item.name];
      return /*#__PURE__*/React.createElement(EmbersDateSelect, {
        key: item.name,
        id: item.name,
        name: item.name,
        label: item.label,
        locale: locale,
        selection: itemValue === null || itemValue === void 0 ? void 0 : itemValue.selection,
        value: itemValue === null || itemValue === void 0 ? void 0 : itemValue.value,
        onPickRange: function onPickRange(range, selection) {
          if (selection) {
            handleFilterChange(item.name, {
              value: selection === null || selection === void 0 ? void 0 : selection.value,
              selection: selection === null || selection === void 0 ? void 0 : selection.option,
              range: range
            });
          }
        }
      });
    }
    var options = _toConsumableArray((_item$options = item.options) !== null && _item$options !== void 0 ? _item$options : []);
    var multiple = (_item$multiple = item.multiple) !== null && _item$multiple !== void 0 ? _item$multiple : true;
    var showBlankOption = !multiple && filterValue[item.name];
    var blankOption = undefined;
    if (showBlankOption) {
      var _item$labelKey;
      blankOption = _defineProperty({
        code: 'none',
        label: getI18nString(intl, 'embers.select.option.none', '-- None --')
      }, (_item$labelKey = item.labelKey) !== null && _item$labelKey !== void 0 ? _item$labelKey : 'label', getI18nString(intl, 'embers.select.option.none', '-- None --'));
    }
    return /*#__PURE__*/React.createElement(EmbersMiniSelect, _extends({}, item, {
      key: item.name,
      name: item.name,
      options: options,
      multiple: multiple,
      labelKey: (_item$labelKey2 = item.labelKey) !== null && _item$labelKey2 !== void 0 ? _item$labelKey2 : 'label',
      label: item.label,
      value: filterValue[item.name],
      isOptionEqualToValue: function isOptionEqualToValue(option, value) {
        return option.code === value.code;
      },
      onChange: function onChange(value) {
        var _item$onChange;
        (_item$onChange = item.onChange) === null || _item$onChange === void 0 || _item$onChange.call(item, value);
        handleFilterChange(item.name, value);
        return false;
      },
      groupBy: item.groupBy,
      getOptionDisabled: item.getOptionDisabled,
      blankOption: blankOption,
      optionsScrollProps: item.optionsScrollProps
    }));
  })));
}